import { createAction } from '@reduxjs/toolkit';

export interface ChartPoint {
    revenue: number;
    expenses: number;
    profit: number;
}

export interface ChartMetric {
    [date: string]: ChartPoint;
}

export interface ChartResponse {
    titles: string[];
    stats: ChartMetric;
}

export interface StatMetric {
    current: number;
    previous: number;
}

export interface StatResponse {
    sales_amount: StatMetric;
    inventory_count: StatMetric;
    capital_in_cars: StatMetric;
    capital_in_parts: StatMetric;
}

export const listStatsRequest = createAction<{period: string}>('stats/listRequest');
export const listStatsSuccess = createAction<StatResponse>('stats/listSuccess');
export const listStatsFailure = createAction<string>('stats/listFailure');

export const listStatsChartRequest = createAction<{period: string}>('stats/listChartRequest');
export const listStatsChartSuccess = createAction<ChartResponse>('stats/listChartSuccess');
export const listStatsChartFailure = createAction<string>('stats/listChartFailure');

export const resetErrorRequest = createAction('stats/resetErrorRequest');
